export default "__VITE_ASSET__BA8Ygaza__"